import React from 'react';
import 'react-photo-view/dist/react-photo-view.css';
import { PhotoProvider, PhotoView } from 'react-photo-view';

const Gallery = ({ photo }) => {
    return (
        <div>
            <figure>
                <PhotoProvider>
                    <PhotoView src={photo}>
                        <img data-aos="fade-up" data-aos-delay="300" className='bg-center h-72 top-0 object-cover object-top md:w-48 w-full rounded-xl cursor-pointer' src={photo} alt="" />
                    </PhotoView>
                </PhotoProvider>
            </figure>
        </div>
    );
};

export default Gallery;